


















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import moment from 'moment'
import ChartOptionsMenu from './ChartOptionsMenu.vue'

@Component({
    components: {
        ChartOptionsMenu
    }
})
export default class LineVerticalChart extends Vue {
    @Prop({ required: true }) loading!: boolean
    @Prop({ required: true }) title!: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop({ required: true }) data!: any;

    localLoading = true
    noData = false
    categorieLabels: string[] = []

    series = [{
        name: 'Net Profit',
        data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
    }, {
        name: 'Revenue',
        data: [76, 85, 101, 98, 87, 105, 91, 114, 94]
    }, {
        name: 'Free Cash Flow',
        data: [35, 41, 36, 26, 45, 48, 52, 53, 41]
    }]

    chartOptions = {
        theme: {
            mode: 'dark'
        },
        chart: {
            background: '#212121'
        },
        colors: ['#0D47A1', '#B71C1C', '#FEB019', '#00E396', '#775DD0'],
        dataLabels: {
            enabled: false
        },
        bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        yaxis: {
            title: {
                text: '$ (thousands)'
            }
        },
        xaxis: {
            categories: this.categorieLabels
        }
    };

    changeChart (chart: string) {
        this.$emit('change-chart', { index: this.data.widgetId, chart })
    }

    @Watch('loading')
    ondialogPropChange () {
        this.localLoading = this.loading
    }

    getReportData () {
        this.localLoading = true
        this.$store.dispatch('viewReport', {
            reportId: this.data.reportId.reportId,
            reportFilters: []
        })
            .then((resp) => {
                if (resp?.status === 200) {
                    this.formatData(resp.data)
                }
                this.localLoading = false
            })
            .catch((error) => {
                this.localLoading = false
                console.log(error)
            })
    }

    getLastMonths () {
        const months = []
        for (let index = 0; index < 6; index++) {
            months.push(moment().subtract(6 - index, 'months').format('MMMM'))
        }
        this.chartOptions.xaxis.categories = months
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formatData (data: any) {
        if (data.query.length > 0) {
            this.noData = false
            this.getLastMonths()
        } else {
            this.noData = true
        }
    }

    mounted () {
        this.getReportData()
        setInterval(this.getReportData, 300000)
    }
}
